
































































































import { Component, Vue } from "vue-property-decorator";
import HsabTransactions from "@/shared/components/cash/hsabank/HsabTransactions.vue";
import TabGroup from "@/shared/components/ui/TabGroup.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import Tab from "@/shared/components/ui/Tab.vue";
import { TransactionFilter } from "@/shared/types";
import { Prop, Watch } from "@/shared/vuepack";
import { useHsabNotionalAccountTransactionStore } from "@/employee/store/hsabNotionalAccountTransaction";
import { Location } from "vue-router";

@Component({
  components: {
    Tab,
    GenericLoadingSpinner,
    TabGroup,
    HsabTransactions
  }
})
export default class HsabNotionalAccountTransactions extends Vue {

  hsabNotionalAccountTransactionStore = useHsabNotionalAccountTransactionStore();
  searchKey = "";
  TransactionFilter = TransactionFilter;

  @Prop()
  page: number;

  @Prop()
  accountId: number;

  @Prop()
  accountName: string;

  @Prop()
  transactionFilter: TransactionFilter;

  @Prop()
  routeToPages: (pageNumber: number, filter: TransactionFilter) => Location;

  get showExport (): boolean {
    return this.accountTransactionsLoaded;
  }

  get showClearSearch () {
    return this.searchKey;
  }

  get accountTransactionsLoading () {
    return this.hsabNotionalAccountTransactionStore.isLoading(this.accountId);
  }

  get accountTransactionsLoaded () {
    return this.hsabNotionalAccountTransactionStore.isLoaded(this.accountId);
  }

  get accountTransactionsLoadFailed () {
    return this.hsabNotionalAccountTransactionStore.loadingFailed(this.accountId);
  }

  @Watch("accountId")
  onAccountIdChange () {
    this.hsabNotionalAccountTransactionStore.fetchTransactions(this.accountId);
  }

  @Watch("page")
  updatePage () {
    this.hsabNotionalAccountTransactionStore.setPageNumber(this.page);
  }

  mounted () {
    this.hsabNotionalAccountTransactionStore.setPageNumber(this.page);
    this.hsabNotionalAccountTransactionStore.fetchTransactions(this.accountId).then(() => {
      this.onAccountIdChange();
    });
  }

  clearSearch () {
    this.searchKey = "";
  }

  switchPage (newPage: number) {
    this.$router.push(this.routeToPages(newPage, this.transactionFilter));
  }

  exportTransactions () {
    this.hsabNotionalAccountTransactionStore.downloadTransactionExportFile(this.accountId, this.accountName);
  }
}
